<template lang='pug'>
  .mr-stars
    span(v-for="star in stars" v-bind:class="star.class")
    span.ada-tooltip {{ rating }} out of 5 stars
</template>

<script>
  import vueProductSvc from '../services/vueProductSvc';

  export default {
    props: {
      rating: {
        type: Number,
        default: 5
      },
      productId: {
        type: Number
      }
    },

    computed: {
      stars() {
        var starArray = [];
        var floorRating = Math.floor(this.productRating.average || this.rating);
        var ceilRating = Math.ceil(this.productRating.average || this.rating);

        for (var x = 1; x <= 5; x++) {
          starArray.push({
            class: x <= floorRating ? 'icon-star-full' : (x == ceilRating && ceilRating != floorRating) ? 'icon-star-half' : 'icon-star'
          });
        }
        
        return starArray;
      }
    },

    asyncComputed: {
      productRating: {
        get() {
          if (this.productId) {
            return vueProductSvc.getAverageReviewsByProductId({ productId: this.productId }).then(res => res.data);
          } else {
            return Promise.resolve({}).then(res => res);
          }
        },
        default() {
          return {};
        }
      }
    }
  }
</script>
